import config from "../../staticConfig";
import moment from "moment";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { TypeCallerInfor } from "../../types/TypeContact";

export const addEditCallerAction = async (
  actionType: string,
  callerData: TypeCallerInfor,
  existingProfilePhoneNumber: string
): Promise<number> => {
  try {
    let payload;
    const endpointUrl = `${config.apiGatewayEndpoint}/customer`;
    if (actionType === "EDIT") {
      payload = {
        existingProfilePhoneNumber,
        callerData,
      };
    } else {
      const urlParams = new URL(window.location.href).searchParams;
      const agentId = urlParams.get("agentId")!;
      const aName = urlParams.get("agentName")!;
      const queueName = urlParams.get("queueName")!;
      const eType = urlParams.get("endpointType")!;
      const time = moment().format();
      const searchField = `${callerData.customerName.toLowerCase()}_${callerData.company.toLowerCase()}_${
        callerData.phoneNumber
      }`;
      payload = {
        pk: uuid(),
        sk: `${time}|${agentId}`,
        phoneNumber: callerData.phoneNumber,
        timestamp: time,
        customerName: callerData.customerName,
        company: callerData.company,
        agentId: agentId,
        agentName: aName,
        queueName,
        endpointType: eType,
        searchField,
      };
    }

    const response = await axios.post(endpointUrl, {
      actionType,
      data: payload,
    });
    return response.status;
  } catch (error) {
    console.error(error);
    return 500;
  }
};

export const callerInforCompare = (
  callerInfor: TypeCallerInfor,
  updatedCallerInfor: TypeCallerInfor
): boolean => {
  console.log("caller infor", callerInfor, updatedCallerInfor);
  let result = false;
  const keys = Object.keys(callerInfor);
  for (let k of keys) {
    if (callerInfor[k].trim() !== updatedCallerInfor[k].trim()) {
      result = true;
      break;
    }
  }
  return result;
};
